import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useEffect,
    useState,
} from "react";

export interface DriveContextInterface {
    isDriveEdit: boolean;
    isDriveOpen: boolean;
    isAppEdit: boolean;
    isJeeUpdate: boolean
    setIsDriveEditOpen: Dispatch<SetStateAction<boolean>>;
    setIsDriveOpen: Dispatch<SetStateAction<boolean>>;
    setIsAppEdit: Dispatch<SetStateAction<boolean>>;
    setIsJeeUpdate: Dispatch<SetStateAction<boolean>>;
}

export const DriveContext = createContext<DriveContextInterface>({
    isDriveEdit: false,
    isDriveOpen: false,
    isAppEdit: false,
    isJeeUpdate: false,
    setIsDriveEditOpen: () => { },
    setIsDriveOpen: () => { },
    setIsAppEdit: () => { },
    setIsJeeUpdate: () => {}
});

export const DriveContextProvider = ({ children }: { children: ReactNode }) => {
    const [isDriveEdit, setIsDriveEditOpen] = useState<boolean>(false);
    const [isDriveOpen, setIsDriveOpen] = useState<boolean>(false);
    const [isAppEdit, setIsAppEdit] = useState<boolean>(false);
    const [isJeeUpdate, setIsJeeUpdate] = useState<boolean>(false);

    return (
        <DriveContext.Provider
            value={{ isDriveEdit, isAppEdit, isDriveOpen, isJeeUpdate, setIsAppEdit, setIsDriveEditOpen, setIsDriveOpen, setIsJeeUpdate }}
        >
            {children}
        </DriveContext.Provider>
    );
};